/**
 * 创作者中心- 删除会话
 * @returns
 */
import { useAppDispatch } from "@/store/hooks";
import {
  Flex,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Box,
  Select,
  RadioGroup,
  Radio,
  Stack,
} from "@chakra-ui/react";
import down from "@/assets/down.svg";
import { ReactSVG } from "react-svg";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const SaveSuccessModal = (props: Props) => {
  const { isOpen, onClose } = props;
  const navigate = useNavigate();

const handleColse = () => {
  onClose();
  navigate("/creatorcenter/mymodels")
}
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent w="420px" bg="#fff">
        <ModalHeader color="#27314D" fontSize={"18px"}>
          保存成功
        </ModalHeader>
        <ModalCloseButton color={"#B9B9B9"} />
        <ModalBody pb={6}>
          <Box mt="10px" fontSize={"14px"} color="#27314D">
            <Box mr="10px" fontSize="14px" color={"#27314D"}>
                模型发布成功，可至模型管理查看状态
              </Box>
            
          </Box>
          <Flex mt="40px" justifyContent={"flex-end"}>
            <Button
              w="76px"
              h="37px"
              bg="#496AE1"
              color={"#FFFFFF"}
              fontSize="12px"
              fontWeight={"normal"}
              borderRadius={0}
              _hover={{
                bg: "#3F5BC1",
                color: "#E6E6E6",
              }}
              onClick={handleColse}
            >
              确认
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default SaveSuccessModal;
